import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-portal-product-failure-page',
  templateUrl: './portal-product-failure-page.component.html',
  styleUrls: ['./portal-product-failure-page.component.scss']
})
export class PortalProductFailurePageComponent implements OnInit {

  constructor(private navigationService: NavigationService) { }

  ngOnInit() {
    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
